import type {
  FooterVariant,
  FooterNavigationGroup,
  FooterLink,
  HeaderVariant,
  NavigationMenus,
  MainLogoVariant,
} from '../entities';
import { getGlobalConfigByLocale } from './config';
import { LocaleType } from '@benzinga/translate';

export const getMenuByLocale = (
  locale: LocaleType,
  menu: string,
): FooterNavigationGroup[] | NavigationMenus | FooterLink[] | null => {
  const globalConfig = getGlobalConfigByLocale(locale);

  if (globalConfig?.menu?.[menu]) {
    return globalConfig.menu[menu];
  }

  return null;
};

export const getHeaderVariantByLocale = (locale: LocaleType): HeaderVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.headerVariant || 'default';
};

export const getFooterVariantByLocale = (locale: LocaleType): FooterVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.footerVariant || 'default';
};

export const getLogoVariantByLocale = (locale: LocaleType): MainLogoVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.logoVariant || 'default';
};
